var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.formData.title,
            visible: _vm.drawer,
            direction: _vm.direction,
            modal: true,
            "before-close": _vm.handleClose,
            "append-to-body": true,
            size: _vm.formData.width,
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "invoice" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.rules,
                    "label-width": "100px",
                    rules: _vm.rule,
                  },
                },
                [
                  _c("div", { staticClass: "from-item-title mb15" }, [
                    _c("span", [_vm._v("物资信息")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-box" }, [
                    _c(
                      "div",
                      { staticClass: "form-item" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "name" } },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v("物资名称:")]
                            ),
                            _vm._v(" "),
                            !_vm.formData.edit
                              ? _c(
                                  "el-select",
                                  {
                                    staticClass: "countries-select",
                                    attrs: {
                                      "allow-create": "",
                                      size: "small",
                                      filterable: "",
                                      clearable: "",
                                      placeholder: "请选择(输入)物资名称",
                                    },
                                    on: { change: _vm.handleName },
                                    model: {
                                      value: _vm.rules.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.rules, "name", $$v)
                                      },
                                      expression: "rules.name",
                                    },
                                  },
                                  _vm._l(
                                    _vm.formData.selectData,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.name,
                                          value: index,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _c("el-input", {
                                  attrs: {
                                    clearable: "",
                                    size: "small",
                                    placeholder: "请输入物资名称",
                                  },
                                  model: {
                                    value: _vm.rules.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.rules, "name", $$v)
                                    },
                                    expression: "rules.name",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-item" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "cid" } },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v("物资分类:")]
                            ),
                            _vm._v(" "),
                            _c("el-cascader", {
                              attrs: {
                                options: _vm.formData.treeData,
                                size: "small",
                                placeholder: "请选择物资分类",
                                props: { checkStrictly: true },
                                clearable: "",
                              },
                              model: {
                                value: _vm.rules.cid,
                                callback: function ($$v) {
                                  _vm.$set(_vm.rules, "cid", $$v)
                                },
                                expression: "rules.cid",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-item overflow" },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v("规格型号:")]
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                size: "small",
                                maxlength: 20,
                                "show-word-limit": "",
                                placeholder: "请输入规格型号",
                              },
                              model: {
                                value: _vm.rules.units,
                                callback: function ($$v) {
                                  _vm.$set(_vm.rules, "units", $$v)
                                },
                                expression: "rules.units",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-item" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "amount" } },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v("计量单位:")]
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                size: "small",
                                maxlength: 8,
                                "show-word-limit": "",
                                placeholder: "请输入计量单位",
                              },
                              model: {
                                value: _vm.rules.specs,
                                callback: function ($$v) {
                                  _vm.$set(_vm.rules, "specs", $$v)
                                },
                                expression: "rules.specs",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    this.formData.edit && _vm.formData.type === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "form-item",
                            staticStyle: { width: "100%" },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "price" } },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [_vm._v("单价(元):")]
                                ),
                                _vm._v(" "),
                                _c("el-input-number", {
                                  attrs: {
                                    controls: false,
                                    min: 0,
                                    precision: 2,
                                    size: "small",
                                    placeholder: "请输入单价",
                                  },
                                  model: {
                                    value: _vm.rules.price,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.rules, "price", $$v)
                                    },
                                    expression: "rules.price",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-item",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v("生产厂家:")]
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: {
                                maxlength: 50,
                                "show-word-limit": "",
                                clearable: "",
                                size: "small",
                                placeholder: "请输入生产厂家",
                              },
                              model: {
                                value: _vm.rules.factory,
                                callback: function ($$v) {
                                  _vm.$set(_vm.rules, "factory", $$v)
                                },
                                expression: "rules.factory",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-item",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [_vm._v(_vm._s(_vm.$t("public.remarks")) + ":")]
                            ),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                maxlength: "200",
                                "show-word-limit": "",
                                rows: 3,
                                placeholder: _vm.$t("customer.placeholder18"),
                              },
                              model: {
                                value: _vm.rules.mark,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.rules,
                                    "mark",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "rules.mark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  !this.formData.edit
                    ? [
                        _c("div", { staticClass: "from-item-title mb15" }, [
                          _c("span", [_vm._v("入库信息")]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-box" }, [
                          _c(
                            "div",
                            { staticClass: "form-item" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "number" } },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("入库数量:")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input-number", {
                                    attrs: {
                                      controls: false,
                                      min: 0,
                                      max: 1000,
                                      precision: 0,
                                      size: "small",
                                      placeholder: "请输入入库数量",
                                    },
                                    model: {
                                      value: _vm.rules.number,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.rules, "number", $$v)
                                      },
                                      expression: "rules.number",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-item" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "price" } },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("单价(元):")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input-number", {
                                    attrs: {
                                      controls: false,
                                      min: 0,
                                      precision: 2,
                                      size: "small",
                                      placeholder: "请输入单价",
                                    },
                                    model: {
                                      value: _vm.rules.price,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.rules, "price", $$v)
                                      },
                                      expression: "rules.price",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-item",
                              staticStyle: { width: "100%" },
                            },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("入库说明:")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      maxlength: "200",
                                      "show-word-limit": "",
                                      rows: 3,
                                      placeholder: _vm.$t(
                                        "customer.placeholder18"
                                      ),
                                    },
                                    model: {
                                      value: _vm.rules.remark,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.rules,
                                          "remark",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "rules.remark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button from-foot-btn fix btn-shadow" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v(_vm._s(_vm.$t("public.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.loading,
                        size: "small",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleConfirm("ruleForm")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("public.ok")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }